import React, {useState} from 'react';

import classes from './Featured.module.css';
import 'bootstrap/dist/css/bootstrap.min.css'

import EachProduct from "../EachProduct/EachProduct";

import db from "../../data/firebase";
import EachFeaturedProduct from '../EachProduct/EachFeaturedProduct';

function Featured(props){
      const [perfumes, setPerfumes]= useState();
      const [atom, setAtom]= useState();
      let perfumeList=[];
      let featuredPerfumes=[];

      function checking(){
        let i=0;
        db.collection("perfumes").get().then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
                
                let temp={
                    id: doc.id,
                    data: doc.data(),
                }

                if (temp.id==="zgu1HID0ErvlrrFIsbRl"){
                  setAtom(temp);

                }

                else if(window.location.pathname == "/products/men"){
                    if(temp.data.gender=="male"){
                        perfumeList[i]=temp;

                    }
                }
                else if(window.location.pathname == "/products/women"){
                    if(temp.data.gender=="female"){
                        perfumeList[i]=temp;

                    }
                }
                else{
                  perfumeList[i]=temp;
                //   if(temp.data.stock==="available"){
                //     perfumeList[i]=temp;

                // }
                //     perfumeList[i]=temp;

                }
                
                i++;
                
            });
            setPerfumes(perfumeList);
           
    
        });
    }

    function randomPerfumes(){
      
      featuredPerfumes=[perfumes[Math.floor((Math.random() * (perfumes.length)))]];
      let selected=perfumes[Math.floor((Math.random() * (perfumes.length)))];


    
      if(perfumes.length>=3){
        while (featuredPerfumes.length<2){
          if(featuredPerfumes.includes(selected)){
            
            selected=perfumes[Math.floor((Math.random() * (perfumes.length)))];
          }
         
          else{
            featuredPerfumes[featuredPerfumes.length]=selected;
          }

        }
      }
        


      
    
    }

    
    





    return(
        <div className={classes.box}>
         

          {perfumes? randomPerfumes(): checking()}
          
         
             <h3 className={classes.title}><span>{props.title}</span><hr></hr></h3>

        
        <div className={classes.featured}>

          {atom? <EachProduct item={atom} data={atom.data} image={atom.data.images[0]} 
           name={atom.data.name} className={classes.eachItem}
             id={atom.id} getProduct={props.getProduct}
             path="#"/> : null }

       
        
        

          
        {perfumes? featuredPerfumes.map((item)=>(
          
           <EachProduct item={item} data={item.data} image={item.data.images[0]} 
           name={item.data.name} className={classes.eachItem}
             id={item.id} getProduct={props.getProduct}
             path={window.location.pathname}/>

        ))
           
               : null}
               
     
        
        

      </div>  

      <div className={classes.featuredMobile}>

        
          {atom? <EachFeaturedProduct item={atom} data={atom.data} image={atom.data.images[0]} 
           name={atom.data.name} className={classes.eachItem}
             id={atom.id} getProduct={props.getProduct}
             path="#"/> : null }

                    
          {perfumes? featuredPerfumes.map((item)=>(
            <EachFeaturedProduct item={item} data={item.data} image={item.data.images[0]} 
            name={item.data.name} className={classes.eachItem}
              id={item.id} getProduct={props.getProduct}
              path={window.location.pathname}/>

          ))
            
                : null}
                




          </div>  
      </div>
    )
}


export default Featured;   